import { $t } from '@/i18n';
import request from '@/utils/request';

/* 根据关键词搜索组织 */
export function getOrgInfoForKey(params) {
  return request({
    url: `/mct_org/v2`,
    params,
  })
}

/* 获取当前账号组织树形结构查询数据 */
export function getTreeList(params){
  return request({
    url: `/mct_org/tree/v1`,
    params,
  })
}

/* 获取组织详情 */
export function getOrgInfoData(orgId, params) {
  return request({
    url: `/mct_org/${orgId}/v1`,
    params,
  })
}

/* 编辑组织 */
export function updateOrgInfoData(orgId, data){
  return request({
    url: `/mct_org/${orgId}/v1`,
    method: `PUT`,
    data,
  }, {
    success: true,
    successMsg: $t('common.operatorOK')
  });
}

/* 新增组织 */
export function newAddOrg(data){
  return request({
    url: `/mct_org/v1`,
    method: `POST`,
    data,
  }, {
    success: true,
    successMsg: $t('common.operatorOK')
  });
}

/* 删除组织 */
export function deleteOrg(org_id){
  return request({
    url: `/mct_org/${org_id}/v1`,
    method: `DELETE`,
  },{
    success: true,
    successMsg: $t('constant.deletedSuccessfully')
  })
}

// 当前切换的组织列表
export function tabChangeOrganizationList(id) {
  return request({
    url: `/mct_org/switch/${id}/v1`,
  })
}

// 更换组织下所有人员的组织
export function switchOrg(data) {
  return request(
    {
      url: `/worker/org_move/v1`,
      method: 'PUT',
      data
    },
    {
      success: true,
      successMsg: $t('common.operatorOK')
    }
  )
}

// 职员组织修改
export function workerChangeOrg(id, data) {
  return request(
    {
      url: `/worker/${id}/org/v1`,
      method: 'PUT',
      data
    },
    {
      success: true,
      successMsg: $t('common.operatorOK')
    }
  )
}

/* 组织新增修改时选择店铺列表 */
export function getShopListForAM(params){
  return request({
    url: `/mct_org/shop/v1`,
    params
  });
}

/* 获取店铺列表 */
export function getShopDataArr(params){
  return request({
    url: `/shop/v1`,
    params,
  })
}

/* 获取店铺数据 */
export function getShopData(id, params) {
  return request({
    url: `/mct_org/shop/${id}/v1`,
    params,
  })
}

/* 修改商家店铺 */
export function updateShopData(parent_id, data){  
  return request({
    url: `/mct_org/shop/${parent_id}/v1`,
    method: `PUT`,
    data,
  })
}

// 角色列表
export function getRoleList(params) {
  return request({
    url: `/rbac/role/v1`,
    params
  })
}

/* 删除店铺 */
export function removeShopById(shop_id, data){
  return request({
    url: `/mct_org/del/shop/${shop_id}/v1`,
    method: `PUT`,
    data,
  })
}

/* 获取用户列表 */
export function getUserList(params){
  return request({
    url: `/worker/v1`,
    params,
  });
}

/* 获取角色列表 */
export function getRolesData(params){
  return request({
    url: `/rbac/role/v1`,
    params,
  });
}

/* 新增职员 */
export function addNewWorker(data){
  return request({
    url: `/worker/v1`,
    method: `POST`,
    data,
  }, {
    success: true,
    successMsg: $t('common.operatorOK')
  });
}

/* 禁用 / 启用 用户 */
export function updateWorkerStatus(worker_id, data){ /* {enabled: 0 / 1} */
  return request({
    url: `/worker/${worker_id}/enabled/v1`,
    method: `PUT`,
    data,
  },{
    success: true,
    successMsg: $t('common.operatorOK')
  });
}

/* 重置密码 */
export function resetUserPwd(user_id){
  return request({
    url: `/worker/${user_id}/reset/v1`,
    method: `PUT`,
  });
}

/* 删除员工 */
export function deleteUserById(user_id){
  return request({
    url: `/worker/${user_id}/v1`,
    method: `DELETE`,
  });
}

// 获取职员信息
export function getWokerInfo(id) {
  return request({
    url: `/worker/${id}/v1`
  })
}

// 修改职员
export function editWorker(id, data) {
  return request(
    {
      url: `/worker/${id}/v1`,
      method: 'PUT',
      data
    },
    {
      success: true,
      successMsg: $t('common.editSuccess')
    }
  )
}

// 职员定制店铺列表
export function workerCustomList(id, params) {
  return request({
    url: `/worker/${id}/shop/v1`,
    params
  })
}

// 职员定制店铺删除
export function workerCustomDelate(id) {
  return request(
    {
      url: `/worker/${id}/shop/v1`,
      method: 'DELETE'
    },
    {
      success: true,
      successMsg: $t('constant.deletedSuccessfully')
    }
  )
}

// 权限列表
export function getModuleList(params) {
  return request({
    url: `/rbac/module/v1`,
    params
  })
}

// 角色新增
export function addRole(data) {
  return request(
    {
      url: `/rbac/role/v1`,
      method: 'POST',
      data
    },
    {
      success: true,
      successMsg: $t('common.operatorOK')
    }
  )
}

// 角色修改
export function editRole(id, data) {
  return request(
    {
      url: `/rbac/role/${id}/v1`,
      method: 'PUT',
      data
    },
    {
      success: true,
      successMsg: $t('common.operatorOK')
    }
  )
}

// 角色删除
export function deleteRole(id) {
  return request(
    {
      url: `/rbac/role/${id}/v1`,
      method: 'DELETE'
    },
    {
      success: true,
      successMsg: $t('constant.deletedSuccessfully')
    }
  )
}

// 角色详情
export function getRole(id) {
  return request({
    url: `/rbac/role/${id}/v1`
  })
}

// 消息通知列表
export function messageList(params) {
  return request({
    url: '/mct_msg/v1',
    params
  })
}

// 消息配置信息修改
export function messageEdit(data) {
  return request(
    {
      url: `/mct_msg/v1`,
      method: 'POST',
      data
    },
    {
      success: true,
      successMsg: $t('common.editSuccess')
    }
  )
}

// 消息配置详情
export function messageDetail(id) {
  return request({
    url: `/mct_msg/${id}/v1`
  })
}

// 查询消息职员信息
export function searchWorkerInfo(params) {
  return request({
    url: `/mct_msg/worker/v1`,
    params
  })
}